<template #content>
    <Dialog 
        :visible="visible" 
        @update:visible="updateVisible"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-3"
        modal >
        <template #header>
            <div class="font-semibold text-lg">
                <i class="pi pi-unlock"></i> Autorização
            </div>
        </template>
        <form @submit.prevent="onSubmit(form)">
            <div class="w-full">
                <div class="text-red-500">{{ message }}</div>
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="login" v-model="form.login" class="w-full" />
                        <label for="login">Login</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['login'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <Password id="senha" v-model="form.senha" class="w-full" inputClass="w-full" :feedback="false" toggleMask />
                        <label for="senha">Senha</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['senha'] }}</div>
                </div>
            </div>

            <div class="flex justify-content-end gap-1">
                <Button 
                    type="submit" 
                    label="Salvar" 
                    severity="success"
                    icon="pi pi-save" 
                    class="flex align-items-center justify-content-center" 
                    :loading="isLoading" />
                <Button 
                    label="Fechar" 
                    severity="warn"
                    icon="pi pi-times" 
                    @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center" 
                    :loading="isLoading" />
            </div>
        </form>

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';

export default {
    components: { Dialog, 
                  FloatLabel, 
                  Button,
                  InputText, 
                  Password,
                  Button
                },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Object,
            default: {}
        },
        message: null,
    },
    emits: ['submit','close'],
    data() {
        return {
            form: {},
            isLoading: false,
        }
    },
    methods: {
        onShow() {
        },
        onHide() {
            this.form = {};
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        onSubmit(form) {
            this.$emit('submit', form);
            // this.errors = {};
            // this.isLoading = true;
            // Auth.profile(form)
            //     .then(response => {
            //         this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: response.data.msg, life: 3000 });
            //         this.$emit('save', response.data.data);
            //         this.$emit('close');
            //     })
            //     .catch(error => {
            //         if(error.response) {
            //             let err = error.response.data;
            //             if(err.erros) {
            //                 for(let i in err.erros) {
            //                     this.errors[i] = err.erros[i][0];
            //                 }
            //                 return;
            //             }
            //             if(error.response.data.msg) {
            //                 this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
            //                 return;
            //             }
            //         }
            //         this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
            //     })
            //     .finally(() => {
            //         this.isLoading = false;
            //     });
        }
    }
}
</script>